import { useState, useEffect } from 'react';
import css from './Snackbar.module.scss';
import classNames from 'classnames';
import { useNoAnimations } from '../../../context/Kiosk/kiosk';
import { useLocalization } from '../../../context/Localization/localization';
import { Snack, SnackbarProps } from './Snackbar.types';
import { BaseSnackbar } from '../BaseSnackbar/BaseSnackbar';
import { TransitionLeft } from '../TransitionLeft/TransitionLeft';
import { GMRoundedIcon, GMSizedIcon } from '../../Icon';
import { TransitionLeftComponent } from '../TransitionLeft/TransitionLeft.types';

const SnackDuration = 3000;
const SlideDuration = 300;

export const Snackbar = (({
    snack,
}: SnackbarProps) => {
    const [transition] = useState<TransitionLeftComponent>(() => TransitionLeft);
    const [currentSnack, setCurrentSnack] = useState<Snack | undefined>(snack);
    const [open, setOpen] = useState<boolean>(!!currentSnack);
    const noAnimations: boolean = useNoAnimations();
    const Localization = useLocalization();

    useEffect(() => {
        setOpen(!!currentSnack);
    }, [currentSnack]);

    useEffect(() => {
        let timeout: any = null;

        if (currentSnack) {
            if (snack?.key !== currentSnack?.key) {
                setOpen(false);

                timeout = setTimeout(() => setCurrentSnack(snack), SlideDuration);
            }
        }
        else {
            setCurrentSnack(snack);
        }

        return () => clearTimeout(timeout);
    }, [snack, currentSnack]);

    return currentSnack ? (
        <BaseSnackbar
            open={open}
            snackbarKey={currentSnack.key}
            onClose={() => setOpen(false)}
            autoHideDuration={SnackDuration}
            TransitionComponent={transition}
            TransitionProps={{ onExited: currentSnack.onClose,
                timeout: SlideDuration,
                appear: !noAnimations }}
            anchorOrigin={{ vertical: 'top',
                horizontal: 'left' }}
            classes={{ root: classNames(css.snackbar, css.success),
                anchorOriginTopLeft: css.topLeft }}
        >
            <div
                role={'button'}
                className={classNames(css.snackBarContent, css.success)}
                onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    setOpen(false);
                }}
            >
                <div className={css.icon}>
                    <GMRoundedIcon roundedBackgroundSize={'extraSmall'} themeType={'primary'}>
                        <GMSizedIcon
                            iconSize={'small'}
                            iconType={'Complete'}
                            ariaLabel={Localization.CompleteCheckmarkIcon}
                        />
                    </GMRoundedIcon>
                </div>
                <div className={css.details}>
                    <div className={css.label}>{currentSnack.label}</div>
                    <div className={css.description}>{currentSnack.description}</div>
                </div>
            </div>
        </BaseSnackbar>
    ) : null;
});
